import type { SVGProps } from "react";

interface LogoProps extends SVGProps<SVGSVGElement> {
  /** Size in pixels for width/height (default 36) */
  size?: number;
}

export function Logo({ size = 36, className = "", ...props }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -6 20 20"
      fill="none"
      aria-hidden
      width={size}
      height={size}
      className={className}
      {...props}
    >
      <title>Scaffolder Near Me</title>
      <g fill="currentColor" fillRule="evenodd" transform="translate(-84, -3165)">
        <path d="M100,3171 C98.897,3171 98,3170.103 98,3169 C98,3167.897 98.897,3167 100,3167 C101.103,3167 102,3167.897 102,3169 C102,3170.103 101.103,3171 100,3171 M94,3171 C92.897,3171 92,3170.103 92,3169 C92,3167.897 92.897,3167 94,3167 C95.103,3167 96,3167.897 96,3169 C96,3170.103 95.103,3171 94,3171 M88,3171 C86.897,3171 86,3170.103 86,3169 C86,3167.897 86.897,3167 88,3167 C89.103,3167 90,3167.897 90,3169 C90,3170.103 89.103,3171 88,3171 M100,3165 C98.798,3165 97.733,3165.541 97,3166.38 C96.267,3165.541 95.202,3165 94,3165 C92.798,3165 91.733,3165.541 91,3166.38 C90.267,3165.541 89.202,3165 88,3165 C85.791,3165 84,3166.791 84,3169 C84,3171.209 85.791,3173 88,3173 C89.202,3173 90.267,3172.459 91,3171.62 C91.733,3172.459 92.798,3173 94,3173 C95.202,3173 96.267,3172.459 97,3171.62 C97.733,3172.459 98.798,3173 100,3173 C102.209,3173 104,3171.209 104,3169 C104,3166.791 102.209,3165 100,3165" />
      </g>
    </svg>
  );
}
